import FilterParameterDto from "../datasourcemodule/FilterParameterDto";
import DataTableFieldParameterDefinitionDto from "../datasourcemodule/DataTableFieldParameterDefinitionDto";

class PathDataTableMappingDto {
    FieldReferenceId: number;
    TransformationLogicId: number;
    TransformationParameters: string;
    AggregationGroupBy: boolean;
    AggregationLogicId: number | null;
    AggregationParameters: string | null;
    DisplayName: string;
    IsSelected: boolean;
    Filters: FilterParameterDto[];
    DeclaredVariables: DataTableFieldParameterDefinitionDto[];

    constructor(
        fieldReferenceId: number,
        transformationLogicId: number,
        transformationParameters: string,
        aggregationGroupBy: boolean,
        aggregationLogicId: number | null,
        aggregationParameters: string | null,
        displayName: string,
        isSelected: boolean = true,
        filters: FilterParameterDto[],
        declaredVariables: DataTableFieldParameterDefinitionDto[] = []
    ) {
        this.FieldReferenceId = fieldReferenceId;
        this.TransformationLogicId = transformationLogicId;
        this.TransformationParameters = transformationParameters;
        this.AggregationGroupBy = aggregationGroupBy;
        this.AggregationLogicId = aggregationLogicId;
        this.AggregationParameters = aggregationParameters;
        this.DisplayName = displayName;
        this.IsSelected = isSelected;
        this.Filters = filters;
        this.DeclaredVariables = declaredVariables;
    }
}

export default PathDataTableMappingDto;
